import React from 'react';
const EnvStateContext = /*#__PURE__*/React.createContext();
const EnvDispatchContext = /*#__PURE__*/React.createContext();
const initialState = {
  base_url: null,
  api_url: null,
  discourse_api_username_prefix: null,
  product: null,
  is_dmable_product: false,
  is_group_dmable_product: false,
  has_default_category_product: false,
  is_outside_forum: null,
  layout_width: 0,
  topics_height_override: null,
  pm_screen_height_override: null
};

/** REDUCER **/

function EnvReducer(state, action) {
  switch (action.type) {
    case 'SET_BASE_URL':
      return {
        ...state,
        base_url: action.payload
      };
    case 'SET_API_URL':
      return {
        ...state,
        api_url: action.payload
      };
    case 'SET_DISCOURSE_API_USERNAME_PREFIX':
      return {
        ...state,
        discourse_api_username_prefix: action.payload
      };
    case 'SET_PRODUCT':
      return {
        ...state,
        product: action.payload
      };
    case 'SET_IS_DMABLE_PRODUCT':
      return {
        ...state,
        is_dmable_product: action.payload
      };
    case 'SET_IS_GROUP_DMABLE_PRODUCT':
      return {
        ...state,
        is_group_dmable_product: action.payload
      };
    case 'SET_HAS_DEFAULT_CATEGORY_PRODUCT':
      console.log('Context env: SET_HAS_DEFAULT_CATEGORY_PRODUCT', action.payload);
      return {
        ...state,
        has_default_category_product: action.payload
      };
    case 'SET_IS_OUTSIDE_FORUM':
      return {
        ...state,
        is_outside_forum: action.payload
      };
    case 'SET_LAYOUT_WIDTH':
      return {
        ...state,
        layout_width: action.payload
      };
    case 'SET_TOPICS_HEIGHT_OVERRIDE':
      return {
        ...state,
        topics_height_override: action.payload
      };
    case 'SET_PM_SCREEN_HEIGHT_OVERRIDE':
      return {
        ...state,
        pm_screen_height_override: action.payload
      };
    default:
      {
        throw new Error('Unhandled action type caught');
      }
  }
}

/** PROVIDER **/
function EnvProvider({
  value,
  children
}) {
  const [state, dispatch] = React.useReducer(EnvReducer, initialState);
  return /*#__PURE__*/React.createElement(EnvStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(EnvDispatchContext.Provider, {
    value: dispatch
  }, children));
}

/** STATE/DISPATCH HOOKS **/
function useEnvState() {
  const context = React.useContext(EnvStateContext);
  if (context === undefined) {
    throw new Error('useEnvState must be used within a EnvProvider');
  }
  return context;
}
function useEnvDispatch() {
  const context = React.useContext(EnvDispatchContext);
  if (context === undefined) {
    throw new Error('useEnvDispatch must be used within a EnvProvider');
  }
  return context;
}
export { EnvProvider, useEnvState, useEnvDispatch };
//# sourceMappingURL=index.js.map